<!-- *ngIf="ready" -->
<ng-container>

  <ng-container>
    <div class="butonera">
      <button type="button" (click)="create()" mat-stroked-button class="btn btn-warning btn-circle btn-lg p-0">
        <mat-icon class="mat-icon-add-custom">add</mat-icon>
        <app-help key='Finanzas1'></app-help>
      </button>
    </div>

  </ng-container>

  <ng-container>
    <app-table [columns]="headerTable" [dataSource]="dataSource" [hasButton]="true"
      [actionsTemplate]="actionsButtons"></app-table>

    <!-- <div class="container-fluid">
          <div class="row">
            <div class="col-md-2 col-lg-1 col-xs-12">
              <select id="itemsPerPage" [(ngModel)]="itemsPerPage" (change)="getList()" class="form-control"
                style="margin-left: 20px;">
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="20">20</option>
              </select>
            </div>
            <div class="col-md-10 col-lg-11 col-xs-12">
              <pagination (pageChanged)="pageChanged($event)" [(ngModel)]="currentPage" [totalItems]="totalItems"
                [itemsPerPage]="itemsPerPage" [maxSize]="5" previousText="Anterior"
                style="float: right;margin-right: 20px;" nextText="Siguiente"></pagination>
            </div>
          </div>
        </div> -->
  </ng-container>

  <ng-container *ngIf="empty">
    <div class="text-center">
      <img src="assets/icons/cuentas_bancarias.svg" class="invoiceImage">
      <p style="color: #9e9e9e">No tiene ninguna cuenta bancaria, presione + para crear una.</p>
    </div>
  </ng-container>



  <ng-template #actionsButtons let-uid="uid">
    <ul class="custom-class">
      <li (click)="edit(uid)">
        <a>
          <mat-icon>edit</mat-icon>Editar
        </a>
      </li>
      <li (click)="connectBank(uid)">
        <a>
          <mat-icon>link</mat-icon>Conectar/Desconectar banco
        </a>
      </li>
      <!-- <li (click)="reconcile(uid)">
        <a>
          <mat-icon>account_balance</mat-icon>Conciliación bancaria
        </a>
      </li> -->
      <li (click)="fiscalUse(uid)">
        <a>
          <mat-icon>description</mat-icon>Usar en Impuestos
        </a>
      </li>
      <li (click)="movimientobanco(uid, 1)">
        <a>
          <mat-icon>payment</mat-icon>Traspaso
        </a>
      </li>
      <li (click)="movimientoefectivo(uid, 1)">
        <a>
          <mat-icon>payment</mat-icon>Reintegro Efectivo
        </a>
      </li>
      <li (click)="movimientoefectivo(uid, 2)">
        <a>
          <mat-icon>payment</mat-icon>Ingreso de Efectivo
        </a>
      </li>
      <li (click)="mayor(uid)">
        <a>
          <mat-icon>title</mat-icon>Mayor Contable
        </a>
      </li>
      <li (click)="defaultRemittanceAccount(uid)">
        <a>
          <mat-icon>bookmark</mat-icon>Usar cuenta para domiliación bancaria
        </a>
      </li>
      <li (click)="importTransactions(uid)">
        <a>
          <mat-icon>publish</mat-icon>Importar extracto
        </a>
      </li>
    </ul>
  </ng-template>
</ng-container>
